// extracted by mini-css-extract-plugin
module.exports = {"comp":"ListA4_comp__MPSQd"};